<script lang="ts">
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let text: string;
  export let value: any = null;
  export let type: "primary" | "secondary" = "secondary";
  export let disabled = false;

  function handleClick() {
    dispatch("click", value);
  }
</script>

<button
  on:click={handleClick}
  {disabled}
  class="svelte-button"
  class:secondary={type === "secondary"}
  class:primary={type === "primary"}>{text}<slot /></button
>

<style>
  .svelte-button {
    padding: 10px 20px;

    min-width: 210px;
    height: 60px;

    border-radius: 41px;

    border: none;

    font-size: 18px;
    line-height: 40px;

    text-align: center;

    cursor: pointer;
  }

  .svelte-button.secondary:active,
  .svelte-button.primary:active {
    color: #ffffff;
    background: #8d5fff;
  }  
  
  .svelte-button.secondary:hover,
  .svelte-button.primary:hover {
    color: #ffffff;
    background: #8d5fff;
    transition: .3s ease;
  }

  .primary {
    color: #ffffff;
    background: #8d5fff;
  }

  .secondary {
    color: #8d5fff;
    background: #ffffff;
  }
</style>
